import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

interface CustomStarIconProps extends SvgIconProps {
  fillColor?: string;
  strokeColor?: string;
}

const IconStar: React.FC<CustomStarIconProps> = ({ fillColor = '#FFD644', strokeColor = 'white', ...props }) => {
  return (
    <SvgIcon {...props} viewBox="0 0 38 38">
      <path
        d="M22.0241 4.02699L25.1041 10.2377C25.5241 11.1022 26.6441 11.9317 27.5891 12.0892L33.1698 13.0255C36.7398 13.6257 37.5798 16.2367 35.0073 18.8127L30.6673 23.1877C29.9323 23.928 29.5298 25.3577 29.7573 26.3815L30.9998 31.7977C31.9798 36.0852 29.7223 37.7425 25.9598 35.5025L20.7273 32.3787C19.7823 31.8152 18.2248 31.8152 17.2623 32.3787L12.0333 35.5025C8.28834 37.7425 6.01334 36.066 6.99334 31.7977L8.23585 26.3815C8.46335 25.3577 8.06085 23.928 7.32585 23.1877L2.98584 18.8127C0.432595 16.235 1.25509 13.6257 4.82334 13.0255L10.4058 12.0892C11.3333 11.9317 12.4533 11.1022 12.8733 10.2377L15.9533 4.02699C17.6333 0.65824 20.3633 0.65824 22.0258 4.02699"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default IconStar;
